import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";

type BaseSectionType = 
  | "Emotional Arc & Sentiment" 
  | "Product Options" 
  | "Key Drivers & Risks" 
  | "Strategic Summary" 
  | "Client's Snapshot";

interface CategoryTagProps {
  category: string | { text: string; subtext?: string; hasColon?: boolean };
  isActive?: boolean;
}

const CategoryTag: React.FC<CategoryTagProps> = ({ category, isActive = false }) => {
  const baseStyles = {
    px: 4,
    py: 2,
    fontSize: "xs",
    fontWeight: isActive ? "bold" : "medium",
    whiteSpace: "nowrap",
    rounded: "sm",
    border: "1px solid",
    borderColor: isActive ? "#010064" : "gray.700",
    color: isActive ? "#010064" : "gray.700",
    height: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bg: isActive ? "white" : "transparent",
    transition: "all 0.2s ease-in-out",
  };

  if (typeof category === "string") {
    return <Box {...baseStyles}>{category}</Box>;
  } else {
    return (
      <Flex {...baseStyles}>
        <Text as="span" whiteSpace="nowrap">{category.text}</Text>
        {category.subtext && (
          <Text as="span" fontSize="xs" ml="1px" whiteSpace="nowrap">
            {category.hasColon ? ": " : " "}{category.subtext}
          </Text>
        )}
      </Flex>
    );
  }
};

export default CategoryTag;